var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.993 2.133h2.11M7.047 1.078v2.11m2.109 1.054h1.406M9.86 3.54v1.406M8.454 7.758a4.57 4.57 0 01-4.371-5.906 4.568 4.568 0 106.281 5.484 4.54 4.54 0 01-1.91.422"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMiAxMiI+PHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTUuOTkzIDIuMTMzaDIuMTFNNy4wNDcgMS4wNzh2Mi4xMW0yLjEwOSAxLjA1NGgxLjQwNk05Ljg2IDMuNTR2MS40MDZNOC40NTQgNy43NThhNC41NyA0LjU3IDAgMCAxLTQuMzcxLTUuOTA2IDQuNTY4IDQuNTY4IDAgMSAwIDYuMjgxIDUuNDg0IDQuNTQgNC41NCAwIDAgMS0xLjkxLjQyMiIvPjwvc3ZnPg==";
export { SvgIconMoon as ReactComponent };